/** What the purchase column knows when the cart button is clicked. */
export interface CartFacts {
  /** At least one position carries artwork. */
  hasDesign: boolean;
  /** Sizes the chosen colour offers. */
  sizeCount: number;
  /** Pieces over all sizes. */
  pieces: number;
  quote: 'loading' | 'error' | 'ready';
  /** A handover is in flight. */
  isSubmitting: boolean;
}

export type CartAction =
  | 'none'
  | 'open-start'
  | 'unavailable'
  | 'require-size'
  | 'wait'
  | 'show-quote-error'
  | 'checkout';

/**
 * What a click on the cart button does. The button itself is always
 * active (after Spreadshirt): a greyed-out button does not say what is
 * missing, this names it.
 *
 * The order of the checks is part of the contract — the customer is asked
 * for one thing at a time, in the order they would do it: a design first,
 * then a size, and only then does the price matter.
 */
export function resolveCartAction(facts: CartFacts): CartAction {
  if (facts.isSubmitting) return 'none';
  if (!facts.hasDesign) return 'open-start';
  if (facts.sizeCount === 0) return 'unavailable';
  if (facts.pieces === 0) return 'require-size';
  if (facts.quote === 'loading') return 'wait';
  if (facts.quote === 'error') return 'show-quote-error';
  return 'checkout';
}
